<template>
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
            
      <h1>Inactive Providers</h1>

        <filter-bar
          class="d-flex"
          :filterTextName="moreParams['filter[search_full_name]']"
          placeholder="Search Name"
          @filter-set="setFilter($event)"
          @filter-reset="resetAllFilters()" />


      <div class="card">
        <vuetable ref="vuetable"
          :api-mode="false"
          :data-manager="dataManager"
          :fields="fields"
          :css="css.table"
          :sort-order="sortOrder"
          :sort-params="getSortParam"
          :multi-sort="false"
          :append-params="moreParams"
          :no-data-template="emptyText"
          pagination-path="pagination"

          @vuetable:load-success="onDataLoaded"
          @vuetable:pagination-data="onPaginationData">

          <div slot="display_name" slot-scope="props" class="d-flex align-items-center">
            <div class="rounded-circle circle-cropped avatar-sm mr-2 font-weight-bold text-sm text-center">
              <img v-if="props.rowData.photo_path" :src="props.rowData.photo_url" class="img-fluid">
              <div v-else class="bg-gray-200 text-gray-600 border">{{ props.rowData.initials }}</div>
            </div>

            <div>
              <div>
                <router-link :to="{ name: props.rowData.model == 'App\\Physician' ? 'physicians.show' : 'groups.show', params:{ id:props.rowData.id } }" data-test="viewProviderLink">
                  {{ props.rowData.display_name }}
                </router-link>    
              </div>
              <div>
                <span
                  v-for="specialty in props.rowData.specialties"
                  class="badge bg-teal-200 text-teal-700 mr-1"
                  v-html="specialty.label"
                />
              </div>
            </div>
          </div>

          <template slot="location_primary" slot-scope="props" v-if="props.rowData.location_primary">
            {{ props.rowData.location_primary.city }}{{ props.rowData.location_primary.state ? ', ' + props.rowData.location_primary.state : '' }}
          </template>

          <template slot="last_checkin_id" slot-scope="props" v-if="props.rowData.last_checkin_id">
            <span class="badge" :class="props.rowData.last_checkin.checkin_type.css_class_name">{{ props.rowData.last_checkin.checkin_type.label }}</span>
            <div class="mt-1 text-sm text-gray-600 leading-none">{{ moment(props.rowData.last_checkin.created_at).format('MMM D, YYYY') }}</div>          
          </template>

          <template slot="created_at" slot-scope="props">
            <div class="text-gray-600 text-sm">
              {{ moment(props.rowData.created_at).format('MMM D, YYYY') }}
              <div v-if="props.rowData.user" class="text-sm text-gray-600 mt-1 leading-none">by {{ props.rowData.user.display_name }}</div>
              <div v-else class="mt-1 leading-none"><em>by admin</em></div>
            </div>
          </template>

          <template slot="actions" slot-scope="props">
            <div class="drop-down dropleft">
              <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown">
                  <i class="far fa-ellipsis-h text-xl"></i>
              </a>
              <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
                <router-link :to="{ name: props.rowData.model == 'App\\Physician' ? 'physicians.show' : 'groups.show', params:{ id:props.rowData.id } }" class="dropdown-item">View Profile</router-link>
              </div>
            </div>
          </template>  
        </vuetable>
      </div>

      <div class="background-fix vuetable-pagination d-flex mb-3">
        <vuetable-pagination-info ref="paginationInfo" info-class="pagination-info" class="flex-fill" info-template="{from} to {to} of {total} items" />
        <vuetable-pagination-bootstrap ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage" class="flex-fill text-right" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

  import Vuetable from 'vuetable-2'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
  import FilterBar from '../../components/FilterBar'
  import VuetablePaginationBootstrap from '../../components/VuetablePaginationBootstrap.vue'

  export default {
    mixins: [BreadcrumbsManager],

    components: {
      FilterBar,
      Vuetable,
      VuetablePaginationInfo,
      VuetablePaginationBootstrap,
    },

    data() {
      return {
        data: [],

        emptyText: 'Loading...please wait',

        fields: [           
          {
            name: 'display_name',
            title: 'Name',
            sortField: 'display_name',
          },
          { 
            name: 'location_primary',
            title: 'Location',
            titleClass: 'hidden_mobile',
            dataClass: 'hidden_mobile',
          },
          {
            name: 'last_checkin_id',
            title: 'Last Check-in',
            sortField: 'last_checkin_id',          
          },          
          {
            name: 'created_at',
            title: 'Added',
            sortField: 'created_at',
            titleClass: 'd-none d-md-table-cell',
            dataClass: 'd-none d-md-table-cell',
          },          
          {
            name: 'actions',
            title: '',
          },
        ],

        css: {
          table: {
            tableClass: 'table providers-table',
            ascendingIcon: 'fas fa-sort-alpha-down',
            descendingIcon: 'fas fa-sort-alpha-up'
          },

          pagination: {
            wrapperClass: 'pagination',
            activeClass: 'active',
            disabledClass: 'disabled',
            pageClass: 'page',
            linkClass: 'link',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          },

          icons: {
            first: 'fas fa-angle-double-left',
            prev: 'fas fa-angle-left',
            next: 'fas fa-angle-right',
            last: 'fas fa-angle-double-right',
          },
        },

        sortOrder: [
          {
            field: 'display_name',
            direction: 'asc',
          }
        ],

        moreParams: {
            'filter[search_full_name]': null,
        },

      };
    },

    created() {
      this.fetchInactives();
    },

    activated() {
      this.setBreadcrumbs([
          { text: 'Home', to: { name: 'home' } },
          { text: 'Providers', to: { name: 'physicians.list' } },
          { text: 'Manage Inactive', to: { name: 'physicians.tools.inactive' } },
      ]);

      this.fetchInactives();
    },

    methods: {
      dataManager(sortOrder, pagination) {
        if (this.data.length < 1) return;

        let local = this.data;
        let perPage = 25;

        // sortOrder can be empty, so we have to check for that as well
        if (sortOrder.length > 0) {
          local = _.orderBy(
            local,
            sortOrder[0].sortField,
            sortOrder[0].direction
          );
        }

        if (this.moreParams['filter[search_full_name]'] !== null) {
            local = local.filter(provider => 
                provider.display_name.toLowerCase().includes(this.moreParams['filter[search_full_name]'].toLowerCase())
            );    
        }

        pagination = this.$refs.vuetable.makePagination(local.length, perPage);
        let from = pagination.from - 1;
        let to = from + perPage;

        return {
          pagination: pagination,
          data: _.slice(local, from, to)
        };
      },

      getSortParam: function(sortOrder) {
        return sortOrder.map(function(sort) {
          return (sort.direction === 'desc' ? '-' : '') + sort.field
        }).join(',')
      },

      fetchInactives() {
        axios.get('/api/providers/inactive').then(({data}) => {
          this.data = data;
        })
      },

      setFilter(filterTextName) {
        this.moreParams = {
          'filter[search_full_name]': filterTextName
        }
        Vue.nextTick( () => this.$refs.vuetable.refresh() )
      },
      
      resetAllFilters() {
        this.moreParams['filter[search_full_name]'] = null;
        Vue.nextTick( () => this.$refs.vuetable.refresh() )
      },

      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },

      onChangePage(page) {
        this.$refs.vuetable.changePage(page)
      },

      onDataLoaded() {
        Vue.nextTick( () => {
          if (this.$refs.vuetable.tableData.length == 0) {
            this.emptyText = 'No records found';
          }
        });
      },
    },

    watch: {
      data(newVal, oldVal) {
        this.$refs.vuetable.refresh();
      }
    },

  }
</script>